import { useState, useMemo } from "react";

import { useGetOrganizationRoles } from "@/queries/organizations";

export const useRolesData = (organizationId: number) => {
  const [search, setSearch] = useState("");

  const { data: rolesData, isLoading } = useGetOrganizationRoles(organizationId);

  const roles = useMemo(() => rolesData?.roles || [], [rolesData?.roles]);

  const filteredData = useMemo(
    () => roles.filter(role => role.name.toLowerCase().includes(search.toLowerCase())),
    [roles, search],
  );

  return {
    data: roles,
    filteredData,
    search,
    setSearch,
    isLoading,
  };
};
